import { useMemo } from "react";
import { createOrganizerApi } from "../lib/api";
import { useWedding } from "../contexts/wedding-context";

export function useOrganizerApi() {
  const { slug } = useWedding();
  return useMemo(() => createOrganizerApi(slug), [slug]);
}
